import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _17c7ffe6 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _3cff3a47 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _2ad2af8a = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _74b5e670 = () => interopDefault(import('../pages/search/documents.vue' /* webpackChunkName: "pages/search/documents" */))
const _ef15de48 = () => interopDefault(import('../pages/search/products.vue' /* webpackChunkName: "pages/search/products" */))
const _0cf18f83 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _1b354276 = () => interopDefault(import('../pages/catalog/_slug.vue' /* webpackChunkName: "pages/catalog/_slug" */))
const _184bdfe7 = () => interopDefault(import('../pages/documents/_slug/index.vue' /* webpackChunkName: "pages/documents/_slug/index" */))
const _6dbd0126 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _7fea381b = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _0b3aee3b = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/catalog",
    component: _17c7ffe6,
    name: "catalog___uk"
  }, {
    path: "/search",
    component: _3cff3a47,
    children: [{
      path: "",
      component: _2ad2af8a,
      name: "search___uk"
    }, {
      path: "documents",
      component: _74b5e670,
      name: "search-documents___uk"
    }, {
      path: "products",
      component: _ef15de48,
      name: "search-products___uk"
    }]
  }, {
    path: "/",
    component: _0cf18f83,
    name: "index___uk"
  }, {
    path: "/catalog/:slug",
    component: _1b354276,
    name: "catalog-slug___uk"
  }, {
    path: "/documents/:slug",
    component: _184bdfe7,
    name: "documents-slug___uk"
  }, {
    path: "/news/:slug?",
    component: _6dbd0126,
    name: "news-slug___uk"
  }, {
    path: "/product/:slug?",
    component: _7fea381b,
    name: "product-slug___uk"
  }, {
    path: "/:slug",
    component: _0b3aee3b,
    name: "slug___uk"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
